export const PRIMER_NAME = 'primerName';
export const OLIGO_SEQUENCE = 'oligoSequence';
export const MODIFICATION_5 = 'modification5';
export const MODIFICATION_3 = 'modification3';
